class CityGuideView extends Backbone.View
  events: 'click span.btn-small': 'toggleContentView'
  el: '#content_holder'

  initialize: () ->
    @collapsedHeight = '200px'
    @seeMoreButton = this.$el.find('.btn.icon-arrow-down')
    @seeLessButton = this.$el.find('.btn.icon-arrow-up')
    @contentEl = this.$el.find('.editorial-content')

  toggleContentView: (e) ->
    @actualHeight = @contentEl.find('.inner').height() + 'px'
    currentTargetEl = $(e.currentTarget)

    if currentTargetEl.hasClass 'icon-arrow-down'
      @seeMoreButton.hide()
      @contentEl.animate { 'max-height': @actualHeight }, 300
      @seeLessButton.show()
    else
      @contentEl.animate { 'max-height': @collapsedHeight }, 300
      $('body').animate('scrollTop': @contentEl.offset().top - 200, 300)
      @seeMoreButton.show()
      @seeLessButton.hide()

    @contentEl.toggleClass 'collapse'

module.exports = CityGuideView
